
mutation withdrawalMoonpayOrderConfirm($transaction_id: String!) {
    withdrawalMoonpayOrderConfirm(transaction_id: $transaction_id) 
}
